import { ref, onMounted } from 'vue'
import apiClient from '@/services/api'

export function useHealthCheck() {
  const isConnected = ref(true)
  const connectionStatus = ref('checking')
  const healthData = ref(null)

  const checkHealth = async () => {
    try {
      connectionStatus.value = 'checking'
      const response = await apiClient.get('/health', {
        timeout: 10000
      })
      
      const data = response.data
      const isHealthy = response.status === 200 && data.status === 'Healthy'
      
      isConnected.value = isHealthy
      healthData.value = data
      connectionStatus.value = isHealthy ? 'connected' : 'disconnected'
      
      return isHealthy
    } catch (error) {
      console.error('[useHealthCheck] Health check failed:', error.message)
      isConnected.value = false
      connectionStatus.value = 'disconnected'
      healthData.value = null
      return false
    }
  }

  onMounted(() => {
    checkHealth()
  })

  return {
    isConnected,
    connectionStatus,
    healthData,
    checkHealth
  }
}
